import * as React from 'react';
import TAGPickerDrawerWrapper from './TAGPickerDrawerWrapper';
import TAGTypography from '../TAGTypography/TAGTypography';
import TAGPickerDialogWrapper from './TAGPickerDialogWrapper';

var TAGPickerWrapper = function TAGPickerWrapper(_ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      drawerChildren = _ref.drawerChildren,
      onAccept = _ref.onAccept,
      onClear = _ref.onClear,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      onSetToday = _ref.onSetToday,
      open = _ref.open,
      screenMatch = _ref.screenMatch,
      wrapper = _ref.wrapper;
  var okText = React.createElement(TAGTypography, {
    variant: "buttonLarge"
  }, "Apply");
  var cancelText = React.createElement(TAGTypography, {
    variant: "buttonLarge",
    color: "text.secondary"
  }, "Cancel");
  var clearText = React.createElement(TAGTypography, {
    variant: "buttonLarge",
    color: "text.secondary"
  }, "Reset");
  var todayText = React.createElement(TAGTypography, {
    variant: "buttonLarge"
  }, "Today");
  return React.createElement(React.Fragment, null, screenMatch ? React.createElement(TAGPickerDialogWrapper, {
    open: wrapper === 'Dialog' && open,
    onAccept: onAccept,
    onSetToday: onSetToday,
    onDismiss: onClose,
    onClear: onClear,
    cancelText: cancelText,
    clearable: true,
    showTodayButton: false,
    clearText: clearText,
    okText: okText,
    todayText: todayText,
    color: color
  }, children) : React.createElement(TAGPickerDrawerWrapper, {
    open: open,
    onOpen: onOpen,
    onAccept: onAccept,
    onSetToday: onSetToday,
    onDismiss: onClose,
    onClear: onClear,
    cancelText: cancelText,
    clearable: true,
    clearText: clearText,
    okText: okText,
    showTodayButton: false,
    todayText: todayText,
    color: color
  }, drawerChildren));
};

export default TAGPickerWrapper;